var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-client-table',{attrs:{"columns":_vm.columns,"data":_vm.tableData,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }